import StudentChart from "./StudentChart"

const StudentChartFilter = () => {
  return (
    <div>
        <StudentChart />
    </div>
  )
}

export default StudentChartFilter